import api from '@/apis/di/bankInfoCategoryAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('bankInfoCategory', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_bank_info_category',
    field: {
      key: 'bank_info_category_id',
      code: 'bank_info_category_code',
      name: 'bank_info_category_name',
      quickFollow: 'inactive', // TPNam-2022/05/09 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
